export default "__VITE_ASSET__BG9sT4pD__"